// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"000fdc3e","232":"b12f1648","354":"53ceee13","386":"5beb8cde","426":"df108dca","453":"3bc3c65e","620":"e2ef4ad6","851":"c997891a"}[chunkId] + ".chunk.js";
};